import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Error403Unauthorized } from '@app/components';
import { VisitsHistory } from '@app/components/VisitsHistory';
import { RIGHTS_CLIENTS, RIGHTS_IS_ON } from '@app/constants';
import { useAccessRights } from '@app/hooks';

export const VisitHistoryTab = () => {
  const [searchParams] = useSearchParams();
  const { hasUserRightForModuleView } = useAccessRights(
    RIGHTS_CLIENTS,
    RIGHTS_IS_ON
  );

  const id = useMemo(() => +(searchParams.get('id') || 0), [searchParams]);

  if (!hasUserRightForModuleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div>
      <VisitsHistory clientId={id} />
    </div>
  );
};
